import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import cx from "classnames";
import ReactTooltip from 'react-tooltip'

class Information extends Component {

    constructor(props) {
        super(props);
        this.state = {
            temp_lang: "",
            text: "",
            large: false
        };
    };

    componentWillMount() {
        this.setState({
            temp_lang: this.props.lang,
            text: this.props.text,
            large: this.props.large
        });
    }

    _close() {
        this.props.setLang(false);
    }

    _set() {
        this.props.setLang(this.state.temp_lang);
    }

    _renderText(item) {
        return langRegister.get("information", item, this.state.temp_lang);
    }

    render() {
        return (
            <span className={Styles.iconContainer}>
                <ReactTooltip className={Styles.informationBubble} id='sadFace' effect='solid'>
                    <span>{this._renderText(this.state.text)}</span>
                </ReactTooltip>
                <ReactTooltip className={Styles.informationBubbleMobile} globalEventOff='click' id='sadFace' effect='solid'>
                    <span>{this._renderText(this.state.text)}</span>
                </ReactTooltip>
                <img data-tip data-for='sadFace' className={
                    cx(Styles.infoIcon,
                        {
                            [Styles.infoIconLarge]: this.state.large
                        })}
                     src={require("../../assets/images/info_icon.svg")}
                />
                <img data-tip='custom show' data-event='click focus' data-for='sadFace' className={
                    cx(Styles.infoIconMobile,
                        {
                            [Styles.infoIconLarge]: this.state.large
                        })}
                     src={require("../../assets/images/info_icon.svg")}
                />
            </span>
        );
    }
}

export default Information;


// WEBPACK FOOTER //
// ./src/components/information/component.js